import AssessmentsModel from '../Apis/Assessments'
import Controller from './Controller'

export default class AssessmentsController extends Controller {
  constructor() {
    super(new AssessmentsModel())
  }
}
